import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from "@angular/core";
import { ToggleSectionsForForm } from "src/app/inspection/new-inspection/models/toggle-section";
@Component({
    selector: "im-item-sections",
    templateUrl: "./item-sections.component.html",
    styleUrls: ["./item-sections.component.scss"],
    standalone: false
})
export class ItemSectionsComponent {
  @Input()
  toggleSectionsForForm: ToggleSectionsForForm[] = [];

  @Input()
  accordeonExpanded: boolean = true;

  @Output()
  toggleChanged: EventEmitter<{ formId: string; sectionId: string }> =
    new EventEmitter<{ formId: string; sectionId: string }>();

  constructor() {}

  onToggleChanged(formId: string, sectionId: string) {
    this.toggleChanged.next({ formId, sectionId });
  }
}
